export const BASENAME = ''; // don't add '/' at end off BASENAME
export const BASE_URL = '/dashboard/default';
export const BASE_TITLE = ' | My Website Title';

export const CONFIG = {
  owner: 'arbaab.2022@gmail.com',
  layout: 'vertical', // vertical, horizontal
  subLayout: 'layout-8', // null, layout-2, layout-2-2, layout-3, layout-4, layout-4-2, layout-6, layout-8
  collapseMenu: false, // mini-menu
  layoutType: 'menu-dark', // menu-dark, menu-light, dark
  navIconColor: false,
  headerBackColor: 'header-default', // header-default, header-blue, header-red, header-purple, header-lightblue, header-dark
  navBackColor: 'navbar-default', // navbar-default, navbar-blue, navbar-red, navbar-purple, navbar-lightblue, navbar-dark
  navBrandColor: 'brand-default', // brand-default, brand-blue, brand-red, brand-purple, brand-lightblue, brand-dark
  navBackImage: false, // false, navbar-image-1, navbar-image-2, navbar-image-3, navbar-image-4, navbar-image-5
  rtlLayout: false,
  navFixedLayout: true, // only for vertical layouts
  headerFixedLayout: false, // only for vertical layouts
  boxLayout: false,
  navDropdownIcon: 'style1', // style1, style2, style3
  navListIcon: 'style1', // style1, style2, style3, style4, style5, style6
  navActiveListColor: 'active-default', // active-default, active-blue, active-red, active-purple, active-lightblue, active-dark
  navListTitleColor: 'title-default', // title-default, title-blue, title-red, title-purple, title-lightblue, title-dark
  navListTitleHide: false,
  configBlock: true,
  layout6Background: 'linear-gradient(to right, #A445B2 0%, #D41872 52%, #FF0066 100%)', // used only for pre-layout = layout-6
  layout6BackSize: '', // 'auto' - for background pattern, 'cover' - for background images & used only for pre-layout = layout-6
  firebase: {
    // apiKey: "AIzaSyDqCr5MpovpWRrz3NC0a30OnJ5IBrLf2XE",
    // authDomain: "fir-react-31a11.firebaseapp.com",
    // projectId: "fir-react-31a11",
    // storageBucket: "fir-react-31a11.appspot.com",
    // messagingSenderId: "461644634069",
    // appId: "1:461644634069:web:d7300aa7f4a716c22bcf5c",
    // measurementId: "G-1YDCPD1R68",
    // databaseURL: "https://fir-react-31a11-default-rtdb.firebaseio.com",
    apiKey: "AIzaSyCH23lNAv0OAdVzw0w3B7n4dJopOrr-Sr4",
    authDomain: "arbaab-5a181.firebaseapp.com",
    databaseURL: "https://arbaab-5a181-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "arbaab-5a181",
    storageBucket: "arbaab-5a181.appspot.com",
    messagingSenderId: "864315381508",
    appId: "1:864315381508:web:3f139063afe395decb6251",
    measurementId: "G-4EEEH71C0E"
  }
};
